module.exports = __webpack_public_path__ + "static/media/SelfLovePackage.515f79cf.jpg";